import { render } from "./MusicXml.vue?vue&type=template&id=3695f162"
import script from "./MusicXml.vue?vue&type=script&lang=js"
export * from "./MusicXml.vue?vue&type=script&lang=js"

import "./MusicXml.vue?vue&type=style&index=0&id=3695f162&lang=less"

import exportComponent from "F:\\TheDreamMusic\\aimusicxml\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__